<div class="pagination-inline">
  <span class="pagination-total-text">
    <strong>{{ start }}</strong> - <strong>{{ end }}</strong> of <strong>{{ total }}</strong>
  </span>
  <div class="pagination-arrows">
    <button
      type="button"
      class="pagination-arrow-btn accello-icon-btn"
      [disabled]="disablePrev"
      (click)="prev.emit()"
      aria-label="Previous page"
    >
      <img src="assets/images/virtusa-icons/page-arrow.svg" alt="previous" class="arrow-icon arrow-left" />
    </button>
    <button
      type="button"
      class="pagination-arrow-btn accello-icon-btn"
      [disabled]="disableNext"
      (click)="next.emit()"
      aria-label="Next page"
    >
      <img src="assets/images/virtusa-icons/page-arrow.svg" alt="next" class="arrow-icon" />
    </button>
  </div>
</div>
